import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import cert1 from '../../assets/cert.png';
import cert2 from '../../assets/cert2.png';

export const Page10: React.FC = () => {
    const certifications = [
        {
            image: cert1,
            alt: 'Certification 1',
        },
        {
            image: cert2,
            alt: 'Certification 2',
        },
    ];

    return (
        <Container maxWidth={false} sx={{ paddingTop: '50px', paddingBottom: '50px', backgroundColor: '#fff' }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: {
                        sx: 1,
                        sm: 2,
                        lg: 5
                    },
                }}
            >
                <Typography
                    sx={{
                        fontFamily: 'ClaireMurphy',
                        fontSize: {
                            xs: '30px',
                            sm: '40px',
                            md: '50px',
                        },
                        fontWeight: 400,
                        textAlign: 'center',
                        color: 'rgba(61, 61, 61, 1)',
                        marginBottom: {
                            xs: '20px',
                            md: '30px'
                        },
                    }}
                >
                    CERTIFICATION
                </Typography>

                <Typography
                    sx={{
                        fontFamily: 'Quicksand, sans-serif',
                        fontSize: {
                            xs: '16px',
                            sm: '18px',
                            md: '20px',
                        },
                        fontWeight: 400,
                        lineHeight: {
                            xs: '24px',
                            sm: '28px',
                            md: '32px',
                        },
                        textAlign: 'center',
                        color: 'rgba(136, 136, 136, 1)',
                        maxWidth: {
                            xs: '100%',
                            md: '800px',
                        },
                        marginBottom: {
                            xs: '30px',
                            md: '50px'
                        },
                    }}
                >
                    Bielenda's commitment to quality and excellence is validated through industry-recognized certifications. These certifications demonstrate Bielenda's dedication to maintaining the highest standards in skincare formulation, safety, and effectiveness. We are proud to showcase Bielenda's credentials that reflect their ongoing commitment to providing you with premium, trusted skincare solutions.
                </Typography>

                {/* Stacked Layout - Top and Below */}
                <Grid container spacing={0} sx={{ width: '100%', maxWidth: '1200px' }}>
                    {certifications.map((cert, index) => (
                        <Grid item xs={12} key={index}>
                            <Box
                                sx={{
                                    width: '100%',
                                    height: {
                                        xs: '300px',
                                        sm: '350px',
                                        md: '400px',
                                        lg: '450px',
                                    },
                                    overflow: 'hidden',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginBottom: index < certifications.length - 1 ? {
                                        xs: '20px',
                                        md: '30px'
                                    } : 0,
                                    '&:hover': {
                                        transform: 'scale(1.02)',
                                        transition: 'transform 0.3s ease',
                                    },
                                }}
                            >
                                <Box
                                    component="img"
                                    src={cert.image}
                                    alt={cert.alt}
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',
                                    }}
                                />
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Container>
    );
};
